import { UitkRatingIcon } from "uitk-react-rating";

enum localeType {
  EN_AU = "en_AU",
}

export const ratingIcon = (locale: string): UitkRatingIcon => {
  return locale === localeType.EN_AU ? "alternate" : "star";
};
